import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { MappedTasksType } from "../JobDetails";
import { statusColors } from "../GanttChart";

const tableHeaders = [
    {
        label: 'MAP INDEX', 
        value: 'map_index',
    },
    {
        label: 'STATE',
        value: 'state',
    },
    {
        label: 'DURATION',
        value: 'duration',
    },
    {
        label: 'START DATE',
        value: 'start_date',
    },
    {
        label: 'END DATE',
        value: 'end_date',
    },
    {
        label: 'TRY NUMBER',
        value: 'try_number',
    }
]

export default function MappedTasksPanel({
    mappedTasks,
}: {
    mappedTasks: MappedTasksType[],
}) {

    
    return (
        <div className="w-full">
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {tableHeaders.map(header => (
                                <TableCell sx={{
                                    fontSize: '10px',
                                    fontFamily: 'Montserrat',
                                    padding: '4px 16px',
                                    background: 'none',
                                }}>{header.label}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {mappedTasks.map((task,i) => (
                            <TableRow key={i} sx={{
                                '&:nth-of-type(odd)': {
                                    backgroundColor: '#EDF0FF',
                                },
                                '&:nth-of-type(even)': {
                                    backgroundColor: 'white',
                                }
                            }}>
                                {tableHeaders.map(header => {
                                    const matchingKey = Object.keys(task).find(k => k === header.value);
                                    if (matchingKey) {
                                        const value = task[matchingKey as keyof object];

                                        return (
                                            <TableCell sx={{
                                                fontSize: '12px',
                                                fontFamily: 'Montserrat',
                                                padding: '12px 16px',
                                            }}>
                                                <div className="flex justify-start items-center gap-3">
                                                    {header.value === 'state' && <div style={{ backgroundColor: statusColors[value as keyof object] }} className={`w-[10px] aspect-square rounded-sm`}></div>}
                                                    <p className='font-medium'>{value}</p>
                                                </div>
                                            </TableCell>
                                        )
                                    } else {
                                        return null;
                                    }
                                })}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}